import { ThemeEvents, VariantUpdateEvent } from '@theme/events'

/**
 * A custom element that displays a variant subheadline metafield.
 * This component listens for variant update events and updates the subheadline display accordingly.
 */
class VariantSubheadline extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSubheadline)
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSubheadline)
  }

  /**
   * Updates the subheadline display when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSubheadline = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return
    }

    const newSubheadline = event.detail.data.html.querySelector('variant-subheadline .text-block')
    const currentSubheadline = this.querySelector('.text-block')

    if (!newSubheadline || !currentSubheadline) return

    if (currentSubheadline.innerHTML !== newSubheadline.innerHTML) {
      currentSubheadline.innerHTML = newSubheadline.innerHTML
    }
  }
}

customElements.define('variant-subheadline', VariantSubheadline) 